import { notFound } from "next/navigation";

import Page from "@components/cmsTemplates/Page";
import HeadSeo from "@components/HeadSeo/HeadSeo";
// import { initEmptySeoTemplate } from "@components/HeadSeo/emptyTemplate";
import { getTemplatePageData } from "@config/cms";
import { useStore } from "@hooks/useZustandProvider";

const RenderTemplate = (props) => {
  const { cms, ssrData } = useStore();
  const { isEditMode } = cms.uiOptions;

  const { draft, lang, isPageNotFound } = cms.page;
  const slugs = props?.initialZustandState?.slugs;
  const type = props?.initialZustandState?.type;
  const seo = props?.data?.data?.seo;
  const properties = props?.data?.properties;

  const templateEmptyLangData = getTemplatePageData();
  const draftLangData = draft?.languages?.[lang] || templateEmptyLangData;

  const blocks = isEditMode
    ? draftLangData?.pageData?.blocks || []
    : props?.data?.data?.pageData?.blocks || [];

  // const seo = isEditMode
  //   ? draftLangData?.seo || initEmptySeoTemplate
  //   : props?.data?.data?.seo || initEmptySeoTemplate;

  // if (isPageNotFound) {
  //   return notFound();
  // }

  return (
    <>
      {!isEditMode && (
        <HeadSeo seo={seo} slugs={slugs} type={type} properties={properties} />
      )}
      <Page blocks={blocks} loading={props.loading} />
    </>
  );
};
export default RenderTemplate;
